<template>
  <div class="page">
    <div class="page-head">
      <h3>센터 조회</h3>
      <div class="head-btns">
        <button class="primary" @click="openAdd">센터 추가</button>
        <button class="ghost" :disabled="!selected" @click="openLeader">센터장 설정</button>
      </div>
    </div>

    <div class="toolbar">
      <label>센터명</label>
      <input v-model="centerName" type="text" placeholder="센터명" @keyup.enter="reload" />
      <label>센터장</label>
      <input v-model="leaderName" type="text" placeholder="센터장" @keyup.enter="reload" />
      <button @click="reload">조회</button>
    </div>

    <div class="table-scroll">
      <table class="grid">
        <thead>
          <tr><th class="c">선택</th><th>센터명</th><th>센터장</th></tr>
        </thead>
        <tbody>
          <tr v-for="r in rows" :key="r.id" :class="{sel: selected && selected.id===r.id}" @click="selected=r">
            <td class="c"><input type="radio" :checked="selected && selected.id===r.id" @change="selected=r" /></td>
            <td>{{ r.centerName }}</td>
            <td>{{ r.leaderName || '-' }}</td>
          </tr>
          <tr v-if="rows.length===0"><td colspan="3" class="empty">데이터가 없습니다.</td></tr>
        </tbody>
      </table>
    </div>

    <Paging :page="page" :size="size" :total-count="total" :total-pages="totalPages"
            @change-page="onPage" @change-size="onSize" />

    <CenterFormDialog v-if="formOpen" :mode="formMode" :center="formCenter"
                      @saved="onSaved" @close="formOpen=false" />
  </div>
</template>

<script>
import api from '../api';
import Paging from '../components/Paging.vue';
import CenterFormDialog from '../components/CenterFormDialog.vue';

export default {
  name: 'CenterAdmin',
  components: { Paging, CenterFormDialog },
  data() {
    return {
      centerName: '', leaderName: '',
      rows: [], selected: null,
      page: 1, size: 10, total: 0,
      formOpen: false, formMode: 'add', formCenter: null
    };
  },
  computed: { totalPages() { return Math.max(1, Math.ceil(this.total / this.size)); } },
  created() { this.reload(); },
  methods: {
    async load() {
      try {
        const res = await api.centerAdminList({
          centerName: this.centerName, leaderName: this.leaderName, page: this.page, size: this.size
        });
        const d = res.data || {};
        this.rows = d.rows || [];
        this.total = d.total || 0;
      } catch (e) { this.rows = []; this.total = 0; }
    },
    reload() { this.page = 1; this.selected = null; this.load(); },
    onPage(p) { this.page = p; this.selected = null; this.load(); },
    onSize(s) { this.size = s; this.page = 1; this.selected = null; this.load(); },
    openAdd() { this.formMode = 'add'; this.formCenter = null; this.formOpen = true; },
    openLeader() { if (!this.selected) return; this.formMode = 'leader'; this.formCenter = { ...this.selected }; this.formOpen = true; },
    onSaved() { this.formOpen = false; this.reload(); }   // 저장 완료 후 조회 기능 실행
  }
};
</script>

<style scoped>
.page { background: #fff; padding: 20px; border-radius: 8px; }
.page-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.page-head h3 { margin: 0; }
.head-btns button { padding: 7px 16px; border-radius: 5px; cursor: pointer; border: 1px solid #ccc; margin-left: 6px; }
.head-btns .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.head-btns .ghost { background: #eef1f7; color: #33415c; }
.toolbar { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; margin-bottom: 14px; }
.toolbar label { font-size: 13px; color: #555; }
.toolbar input { padding: 7px 9px; border: 1px solid #d0d5dd; border-radius: 5px; }
.toolbar button { padding: 7px 16px; background: #2f6fed; color: #fff; border: none; border-radius: 5px; cursor: pointer; }
.table-scroll { overflow-x: auto; }
.grid { width: 100%; border-collapse: collapse; }
.grid th, .grid td { border: 1px solid #e5e8ef; padding: 8px 10px; font-size: 13px; }
.grid th { background: #f0f3fa; color: #33415c; }
.grid th.c, .grid td.c { text-align: center; width: 60px; }
.grid tr.sel { background: #eaf1ff; }
.grid tbody tr:hover { background: #f6f9ff; cursor: pointer; }
.empty { text-align: center; color: #999; padding: 20px; }
</style>
